var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.urlFormatted.length > 0
    ? _c(
        "a",
        {
          staticClass: "avatar-listing-link",
          attrs: { href: _vm.urlFormatted, target: "_blank" }
        },
        [
          _c(
            "CompassAvatarName",
            {
              attrs: {
                size: _vm.size,
                firstname: _vm.firstname,
                lastname: _vm.lastname,
                "show-caption": false
              }
            },
            [
              _c("CompassAvatar", {
                attrs: {
                  "color-type": _vm.colorType,
                  size: _vm.size,
                  initials: _vm.initials,
                  type: _vm.avatarType
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _c(
        "span",
        [
          _c(
            "CompassAvatarName",
            {
              attrs: {
                size: _vm.size,
                firstname: _vm.firstname,
                lastname: _vm.lastname,
                "show-caption": false
              }
            },
            [
              _c("CompassAvatar", {
                attrs: {
                  "color-type": _vm.colorType,
                  size: _vm.size,
                  initials: _vm.initials,
                  type: _vm.avatarType
                }
              })
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }